export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReEFRVVDLUhhBaGiAb1PDQG9UQkCvVMCBL1WBBG9W0EVoeG9bYU/AAEAAQABAAEAGQAfAAEAAQAGAIEyAAEAAQABAAEAGQAfAAEAAQAGAGEBpfUBvgI=", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/EUC-V.bcmap
// module id = 630
// module chunks = 502